/** Injects a meta tag with the given appId to create a banner to promote the app on the App Store from a website in iOS */
import { documentReady } from './index';
import { featureFlagClient } from '@ringcentral/rwc-utils/src/feature-flag-client';
import { FEATURE_FLAGS } from '@ringcentral/rwc-utils/src/constants/feature-flags';
import { meetingId } from '@low/guard';

function injectAppId(appId: string): void {
    if (!appId) return;

    const element = document.createElement('meta');
    element.name = 'apple-itunes-app';
    element.content = `app-id=${appId}`;

    // Use the app-argument attribute to pass the meeting url to the app when it opens
    if (meetingId) {
        const location = window.location;
        const appArgument = `${location.origin}/join/${meetingId}${location.search}`;

        element.content += `, app-argument=${appArgument}`;
    }

    document.head.appendChild(element);
}

/**
 * According to RCV-42098 ,only pages 'download', 'launcher', 'unsupported' need to add the iOS Smart Banner
 */

function injectAppIdInPageUnableMeeting(): void {
    const appId = featureFlagClient.getFlag(FEATURE_FLAGS.brandInformation).appId as string;
    injectAppId(appId);
}

documentReady(injectAppIdInPageUnableMeeting);
